import { Observable } from 'rxjs/Observable';
import { IDelegationRequest, IUserIDRequest } from './http-requests';
import { AppEndpoints } from '../app.endpoints';
import { MetaData } from '../../globals/classes/urlBuilder';
import { HttpService } from '../../globals/providers/http.service';
import { ISendSmsOtpResponse } from './http-responses';
import { AppSettings } from '../app.settings';

export interface IChangePasswordRequest {
	userID: string;
	oldPassword: string;
	newPassword: string;
	newPasswordConfirm: string;
	otp: string;
	isSmsOtp: string;
	updateUser: string;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
	public userID: string;
	public oldPassword: string;
	public newPassword: string;
	public newPasswordConfirm: string;
	public otp: string;
	public isSmsOtp: string;
	public updateUser: string;

	constructor(request?: IChangePasswordRequest) {
		let newReq: IChangePasswordRequest = request || {
			isSmsOtp: null,
			newPassword: null,
			newPasswordConfirm: null,
			oldPassword: null,
			otp: null,
			updateUser: null,
			userID: null,
		};
		this.read(newReq);
	}

	private read(newRequest: IChangePasswordRequest) {
		this.isSmsOtp = newRequest.isSmsOtp;
		this.newPassword = newRequest.newPassword;
		this.newPasswordConfirm = newRequest.newPasswordConfirm;
		this.oldPassword = newRequest.oldPassword;
		this.otp = newRequest.otp;
		this.updateUser = newRequest.updateUser;
		this.userID = newRequest.userID;
	}
}

export interface IChangePasswordResponse {
	succeeded: boolean;
	tanCheck: string;
	loginError?: string;
}

export class ChangePassword {
	/* Delegate Request */
	public static SendChangeOtpPass(request: IUserIDRequest): Observable<ISendSmsOtpResponse> {
		if (AppSettings.skipDelegationRequest) {
			return HttpService.post<ISendSmsOtpResponse>(AppEndpoints.sendChangePass, request);
		} else {
			return ChangePassword.useDelegateRequestSendChangeOtpPass(
				AppEndpoints.sendChangePass,
				request
			);
		}
	}

	/* Delegate Request */
	public static ChangePassword(
		request: IChangePasswordRequest
	): Observable<IChangePasswordResponse> {
		if (AppSettings.skipDelegationRequest) {
			return HttpService.post<IChangePasswordResponse>(AppEndpoints.changePassword, request);
		} else {
			return ChangePassword.useDelegateRequestChangePassword(
				AppEndpoints.changePassword,
				request
			);
		}
	}

	/* SendChangeOtpPass */
	private static useDelegateRequestSendChangeOtpPass(
		endPointUrl: string,
		request: IUserIDRequest
	): Observable<ISendSmsOtpResponse> {
		return HttpService.post<ISendSmsOtpResponse>(
			AppEndpoints.delegateRequest,
			ChangePassword.setDelegationRequest(endPointUrl, request),
			false
		);
	}

	/* ChangePassword */
	private static useDelegateRequestChangePassword(
		endPointUrl: string,
		request: IChangePasswordRequest
	): Observable<IChangePasswordResponse> {
		return HttpService.post<IChangePasswordResponse>(
			AppEndpoints.delegateRequest,
			ChangePassword.setDelegationRequest(endPointUrl, request),
			false
		);
	}

	private static setDelegationRequest(endPointUrl: string, request: any): IDelegationRequest {
		return {
			audiences: 'LoginApi',
			endPointUrl: endPointUrl,
			body: new MetaData().wrap2Request(request),
		};
	}
}
